import COS from "cos-js-sdk-v5";
import {Md5} from "ts-md5";
import {userUserStore} from "@/store/user.ts";

const CHUNK_SIZE = 1024 * 1024 * 5; // 文件切片大小
const cos = new COS({
    SecretId: import.meta.env.VITE_COS_SECRET_ID,
    SecretKey: import.meta.env.VITE_COS_SECRET_KEY,
    FileParallelLimit: 5,
    ChunkParallelLimit: 3,
    ProgressInterval: 1000,
});

interface UploadCallback {
    onTaskReady(taskId: string): void;
    onProgress(progressData: COS.ProgressInfo): void;
    onUploadFail(error: string): void;
    onFileFinish(url: string): void;
}

const getFileExt = (filename: string): string => filename.split('.').pop() || '';

const hashFilename = (filename: string): string => {
    const userStore = userUserStore();
    return Md5.hashStr(`${userStore.id}_${Date.now()}_${filename}`);
};

// 提取通用上传逻辑
const uploadCommon = (prefix: string, file: File, callback: UploadCallback) => {
    const fileKey = `${prefix}${hashFilename(file.name)}.${getFileExt(file.name)}`;
    cos.uploadFile({
        Bucket: import.meta.env.VITE_COS_BUCKET,
        Region: import.meta.env.VITE_COS_REGION,
        Key: fileKey,
        Body: file,
        SliceSize: CHUNK_SIZE,
        onTaskReady: taskId => callback.onTaskReady(taskId),
        onProgress: progressData => callback.onProgress(progressData),
        onFileFinish: (error, data) => {
            if (error) {
                callback.onUploadFail(error.message);
            } else {
                const url = formatUrl(data.Location);
                callback.onFileFinish(url);
            }
        },
    }, (error, data) => console.warn(error || data));
};

// URL格式化函数
const formatUrl = (location: string): string => {
    const bucketPattern = new RegExp(`${import.meta.env.VITE_COS_BUCKET}.cos.${import.meta.env.VITE_COS_REGION}.myqcloud.com`);
    return `https://${location.replace(bucketPattern, import.meta.env.VITE_COS_DOMAIN)}`;
};

// 具体上传函数变为简单的包装器
export const uploadImage = (file: File, callback: UploadCallback) => uploadCommon("images/", file, callback);

export const uploadFile = (file: File, callback: UploadCallback) => uploadCommon("handouts_file/", file, callback);
